import React from 'react';
import StringField from '@/forms/_fields_v2/StringField';

export default function NumberField(props) {
  return <StringField {...props} inputType="number" />;
}

NumberField.propTypes = {
  ...StringField.propTypes,
};

NumberField.defaultProps = {
  ...StringField.defaultProps,
};
